module.exports = __webpack_public_path__ + "static/media/expert-tiny.cd427800.svg";